import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  InquiryTemplateModuleOption,
  ModuleOptionKey,
  ModulePreviewCounts,
  ModulePreviewMap,
  ModulePreviewStep,
} from 'dashboard/models/inquiry-template-module';

export interface InquiryTemplateModulesState {
  moduleOptions: InquiryTemplateModuleOption[];
  modulePreviewMap: ModulePreviewMap;
}

export const initialState: InquiryTemplateModulesState = {
  moduleOptions: [],
  modulePreviewMap: {},
};

interface SetModuleOptionsPayload {
  moduleOptions: InquiryTemplateModuleOption[];
}

interface SetModulePreviewPayload {
  key: ModuleOptionKey;
  steps: ModulePreviewStep[];
  counts: ModulePreviewCounts;
}

const { reducer, actions } = createSlice({
  name: 'inquiry-template-modules',
  initialState,
  reducers: {
    setInquiryTemplateModuleOptions: (state, action: PayloadAction<SetModuleOptionsPayload>) => {
      state.moduleOptions = action.payload.moduleOptions;
    },
    setInquiryTemplateModulePreview: (state, action: PayloadAction<SetModulePreviewPayload>) => {
      state.modulePreviewMap[action.payload.key] = action.payload;
    },
    clearInquiryTemplateModulePreviewMap: (state) => {
      state.modulePreviewMap = {};
    },
  },
});

export const {
  setInquiryTemplateModuleOptions,
  setInquiryTemplateModulePreview,
  clearInquiryTemplateModulePreviewMap,
} = actions;
export const inquiryTemplateModulesReducer = reducer;
